import React from "react";
import { Dynamic } from "../../../../../controllers/conductor";
import SamedayDashboardController from "../../../../../controllers/dashboard/SamedayDashboard";
import { PieChart } from "../../../../../services/charts";
import { Button } from "../../../../widgets/buttons";
import { MonthYearSelector } from "../../../../widgets/date_selector";
import { LoadingAnimation } from "../../../../widgets/loading";

/**
 * @param {{ controller: SamedayDashboardController }} param0 
 */
export function PieSection({ controller }) {
    
    const radius = 150;
    const height = radius*2 + 10;
    const width = radius*2 + 10;

    const colors = [ "#EB695C", "#F39E50", "#F0D12B", "#79DB69", "#7391DC", "#9A9A9A" ];

    const defaultStroke = { width: 3, color: "#fff" };
    // const pieDataset = [
    //     { label: "Samar", value: 700, style: { fillColor: colors[0], stroke: defaultStroke } },
    //     { label: "Leyte", value: 1300, style: { fillColor: colors[1], stroke: defaultStroke } },
    //     { label: "Southern Leyte", value: 1700, style: { fillColor: colors[2], stroke: defaultStroke } },
    //     { label: "Southern Leyte", value: 200, style: { fillColor: colors[3], stroke: defaultStroke } },
    //     { label: "Southern Leyte", value: 0, style: { fillColor: colors[4], stroke: defaultStroke } },
    //     { label: "Southern Leyte", value: 100, style: { fillColor: colors[5], stroke: defaultStroke } },
    // ];


    const { notifiers, reference: { pie: { month, year } }, data } = controller;


    return <section className="pie-section">
        <Dynamic conductor={[ notifiers.pieLoading, notifiers.pieError ]} child={() => {        
            const tooltips = [];
            const tooltipRefs = {};

            let noData = true;
            const allTotal = data.pie.children.reduce((a, b) => a + (b.total?.all || 0), 0);
            const pieDataset = data.pie.children.map((province, i) => {
                const { id, name, total } = province;
                if(total?.all) noData = false;

                const fraction = total ? Math.round((total?.all / allTotal)*1000)/10 + "%" : "N.D."; 
                

                const tooltipRef = React.createRef();
                if(total) {
                    const tooltip = <div key={i} style={{ borderColor: colors[i] }} className="tooltip" ref={tooltipRef}>
                        <div className="title"><b>{name}</b>{total ? <span className="fraction"> ({fraction})</span> : ""}</div>
                        { total ? <div className="details">
                            <span className="total">{total.all}</span>
                            <span className="all-total">/ {allTotal}</span>
                        </div> : <div className="tooltip-nodata">NO DATA</div> }
                    </div>;

                    tooltips.push(tooltip);
                    tooltipRefs[id] = tooltipRef; 
                }
                

                return { label: `${name} (${fraction})`, value: total?.all || 0, style: { fillColor: colors[i], stroke: defaultStroke },
                    onHover(event) {
                        if(!total) return;

                        const { clientX, clientY, target } = event;

                        const { left, top } = target.parentElement.getBoundingClientRect();
                        
                        const x = clientX - left;
                        const y = clientY - top;

                        const tooltip = tooltipRef.current;
                        if(tooltip) {
                            tooltip.style.left = x + "px";
                            tooltip.style.top = y + "px";
                            tooltip.classList.add("visible");
                        }
                    }, onHoverOut() { if(total) tooltipRef.current?.classList.remove("visible") } };
            });

            return controller.status.pieLoading ? 
                <div className="loading"><center><LoadingAnimation /></center></div> :
                noData ? <div className="nodata">NO DATA</div> :
                <div className="chart-wrapper">
                    <div className="pie-wrapper">
                        <PieChart data={pieDataset} radius={radius} className="pie" center={[ radius+5, radius+5 ]} height={height} width={width} />
                        <div className="components">{tooltips}</div>
                    </div>
                    <div className="legend">
                        {
                            pieDataset.map((item, i) => 
                                <div className="label-item" key={i}>
                                    <div className="label-color" style={{ backgroundColor: colors[i] }} />
                                    <span>{item.label}</span>
                                </div>)
                        }
                    </div>
                </div>;
        }} />
        <div className="menu">
            <div className="title">Sameday Tourist <br /> Arrivals Distribution</div>
            <MonthYearSelector month={month} year={year} onChange={date => controller.changePieDate(date)} /><br />
            <Button onClick={() => controller.downloadPie()} icon="save">Download</Button>
        </div>
    </section>;
}